export default __webpack_public_path__ + "static/media/offlineicon.f7cfb82a.svg";